<template>
    <div id="refresher">

    </div>
</template>

<script>
import PullToRefresh from 'pulltorefreshjs';

export default {
    name: 'refresh',
    data : function () {
        return {
            refresher : null,
            menu : ''
        }
    },
    watch : {
        refreshing : function (val) {
            if (!val) {
                this.stopRefresh();
            }
        }
    },
    props : {
        refreshing : Boolean,
        onRefresh  : Function
    },
    mounted : function () {
        let self = this;
        PullToRefresh.destroyAll();
        this.refresher = PullToRefresh.init({
            shouldPullToRefresh : function () {
                var menu  = document.getElementById('menu'),
                    bound = menu.getBoundingClientRect(),
                    wh    = window.innerHeight,
                    ch    = document.documentElement.clientHeight
                if (bound.top >= 0 && bound.bottom <= (wh || ch)) {
                    return true;
                }
                return false;
            },
            onRefresh : function () {
                self.doRefresh();
            }
        })
    },
    methods : {
        doRefresh : function () {
            this.$parent.refreshing = true;
            this.onRefresh();
        },
        stopRefresh : function () {
            this.$parent.refreshing = false;
        }
    }
}
</script>